// Angular
import { ApplicationRef, ComponentFactoryResolver, ComponentRef, Directive, ElementRef, EmbeddedViewRef, HostListener, Injector, Input, OnDestroy } from '@angular/core';
// Component
import { TooltipComponent } from './tooltip.component';

@Directive({
    selector: '[cvNewTooltip]'
})
export class TooltipNewDirective implements OnDestroy {

    @Input() tooltipText = '';
    @Input() tooltipPlacement: 'top' | 'bottom' | 'right' | 'left' = 'bottom';;
    @Input() disabled: boolean;

    private componentRef: ComponentRef<any> = null;

    constructor(
        private elementRef: ElementRef,
        private applicationRef: ApplicationRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        private injector: Injector) {
    }

    @HostListener('mouseenter')
    onMouseEnter(): void {
        if (this.componentRef === null && !this.disabled) {
            const componentFactory =
                this.componentFactoryResolver.resolveComponentFactory(
                    TooltipComponent);
            this.componentRef = componentFactory.create(this.injector);
            this.applicationRef.attachView(this.componentRef.hostView);
            const domElement =
                (this.componentRef.hostView as EmbeddedViewRef<any>)
                    .rootNodes[0] as HTMLElement;
            document.body.appendChild(domElement);
            this.setTooltipComponent();
        }
    }

    @HostListener('mouseleave')
    onMouseLeave(): void {
        this.destroy();
    }

    ngOnDestroy(): void {
        this.destroy();
    }

    private destroy(): void {
        if (this.componentRef !== null) {
            this.applicationRef.detachView(this.componentRef.hostView);
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }

    /**
     * set tooltip properties
     */
    private setTooltipComponent() {
        if (this.componentRef !== null) {
            this.componentRef.instance.tooltip = this.tooltipText;
            this.componentRef.instance.position = this.tooltipPlacement;
            const { left, right, top, bottom } = this.elementRef.nativeElement.getBoundingClientRect();

            switch (this.tooltipPlacement) {
                case 'bottom': {
                    this.componentRef.instance.left = Math.round((right - left) / 2 + left);
                    this.componentRef.instance.top = Math.round(bottom);
                    break;
                }
                case 'top': {
                    this.componentRef.instance.left = Math.round((right - left) / 2 + left);
                    this.componentRef.instance.top = Math.round(top) - 10;
                    break;
                }
                case 'right': {
                    this.componentRef.instance.left = Math.round(right);
                    this.componentRef.instance.top = Math.round(top + (bottom - top) / 2) - 7;
                    break;
                }
                case 'left': {
                    this.componentRef.instance.left = Math.round(left);
                    this.componentRef.instance.top = Math.round(top + (bottom - top) / 2) - 7;
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }
}